'use client';

import { useSuspenseQuery } from '@apollo/client/react';
import { FC, PropsWithChildren } from 'react';

import { Payment } from '@/.gql/graphql';
import { FIND_PAYMENT } from '@/.graphql';

import { createCustomContext } from './context';

const [Context, useFindPaymentContext] = createCustomContext<Payment | null>({
  name: 'FindPaymentContext',
  strict: false,
});
export { useFindPaymentContext };

interface IFindPaymentProviderProps extends PropsWithChildren {
  paymentId: string;
}
export const FindPaymentProvider: FC<IFindPaymentProviderProps> = ({
  children,
  paymentId,
}) => {
  const { data } = useSuspenseQuery(FIND_PAYMENT, {
    variables: {
      paymentId,
    },
  });

  return <Context value={data?.getPayment}>{children}</Context>;
};
